<template>
  <div class="createPost-container">
    <sticky :z-index="10" :class-name="'sub-navbar'">
      <el-button v-loading="loading" style="margin-left: 10px;" type="primary" @click="save()">
        儲存
      </el-button>
    </sticky>
    <div class="createPost-main-container">
      <el-table
        :data="zoomDatas"
        border
        fit
        highlight-current-row
        style="width:100%;margin-top:30px"
      >
        <el-table-column align="center" label="No" width="200">
          <template slot-scope="scope">
            {{ scope.$index+1 }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="zoom ID" width="200">
          <template slot-scope="scope">
            <el-input v-model="scope.row.zoom_id" placeholder="zoom ID" />
          </template>
        </el-table-column>
        <el-table-column align="center" label="zoom password" width="200">
          <template slot-scope="scope">
            <el-input v-model="scope.row.zoom_pwd" placeholder="zoom password" />
          </template>
        </el-table-column>
        <el-table-column align="center" label="zoom host key" width="200">
          <template slot-scope="scope">
            <el-input v-model="scope.row.zoom_host_key" placeholder="zoom host key" />
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>

import Sticky from '@/components/Sticky'
import UserResource from '@/api/user'
const userResource = new UserResource()

export default {
  name: 'ZoomList',
  components: { Sticky },
  data: function() {
    return {
      zoomDatas: [],
      loading: false,
      errorCodeMessage: {
        0: { 'type': 'success', 'title': ' Success', 'message': ' Success' },
        12: { 'type': 'error', 'title': 'Something went wrong', 'message': 'Please try again. (Error Code 12)' },
        13: { 'type': 'error', 'title': 'Something went wrong', 'message': 'Please try again. (Error Code 13)' },
        23: { 'type': 'warning', 'title': 'Warning', 'message': 'Please try again. (Error Code 23)' }
      }
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      const { data } = await userResource.zoomLists()
      this.zoomDatas = data.items
    },
    save(event) {
      this.$confirm('Are you sure to want to Save all ?', 'Tip', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel'
      }).then(() => {
        this.sendData()
      }).catch(() => {
        return false
      })
    },
    async sendData() {
      const { data } = await userResource.updateZoom(this.zoomDatas)
      const actionTitle = 'Update zooms'
      if (data.code === 0) {
        this.passData()
        this.messageNotify(
          actionTitle + this.errorCodeMessage[data.code]['title'],
          this.errorCodeMessage[data.code]['message'],
          this.errorCodeMessage[data.code]['type']
        )
      } else {
        this.messageNotify(
          actionTitle + this.errorCodeMessage[data.code]['title'],
          this.errorCodeMessage[data.code]['message'],
          this.errorCodeMessage[data.code]['type']
        )
        return false
      }
    },
    passData() {
      this.loadData()
    },
    messageNotify(title, message, type) {
      this.$notify({
        title: title,
        dangerouslyUseHTMLString: true,
        message: `<div>${message}</div>`,
        type: type
      })
    }
  }
}
</script>
